export default {
    FETCHED_EMAIL_TEMPLETE: 'FETCHED_EMAIL_TEMPLETE',
    FETCHED_EMAIL_TEMPLETE_ERROR: 'FETCHED_EMAIL_TEMPLETE_ERROR',
    FETCHED_EMAIL_TEMPLETE_LOADING: 'FETCHED_EMAIL_TEMPLETE_LOADING',
    
    EMAIL_TEMPLETE_ENTRY: "EMAIL_TEMPLETE_ENTRY",
    EMAIL_TEMPLETE_ENTRY_ERROR: "EMAIL_TEMPLETE_ENTRY_ERROR",
    EMAIL_TEMPLETE_ENTRY_LOADING: "EMAIL_TEMPLETE_ENTRY_LOADING",

}